/**
 * 
 * @returns 
 */
export const useMediaQueries = () => {
    const breakpoints = {
        xs: '(min-width: 0px)',
        sm: '(min-width: 640px)',
        md: '(min-width: 768px)',
        lg: '(min-width: 1024px)',
        xl: '(min-width: 1440px)',
        xxl: '(min-width: 1920px)'
    }

    const DEFAULT_BREAKPOINT = 3

    /**
     * Creates a MediaQuery observer via `window.matchMedia`
     *
     * @param {Function} cb - Called everytime a media query has changed
     *
     * @returns {Breakpoint} breakpoint - Current breakpoint
     */
    function observeMediaQueries (cb) {
        const matchedBreakpoints = []
        function onChangeMedia (mediaQuery, mediaIndex = DEFAULT_BREAKPOINT) {
            matchedBreakpoints[mediaIndex] = mediaQuery.matches
    
            const
                currentIndex = [ ...matchedBreakpoints ].reverse().indexOf(true),
                mobile = currentIndex > 2
    
            cb(Object.keys(breakpoints).reverse()[currentIndex], mobile)
        }
    
        if (typeof window !== 'undefined' && window.matchMedia && cb) {
            Object.keys(breakpoints).map((key, index) => {
                const mediaQuery = window.matchMedia(breakpoints[ key ])
    
                mediaQuery.addListener(() => onChangeMedia(mediaQuery, index))
                return onChangeMedia(mediaQuery, index)
            })
        }
        if (typeof window !== 'undefined') {
            const
                index = Object.keys(breakpoints)
                    .map(key => breakpoints[key].match(/\d+/)[0] - 0)
                    .reverse()
                    .findIndex(a => a < window.innerWidth || 0),
                mediaBreakpoint = Object.keys(breakpoints).reverse()[ index ],
                mobile = index > 2
    
            return { mediaBreakpoint, mobile }
        }
        return {
            mediaBreakpoint: Object.keys(breakpoints)[ DEFAULT_BREAKPOINT ],
            mobile: false,
        }
    }

    return {
        breakpoints,
        observeMediaQueries
    }
}